// extracted by mini-css-extract-plugin
export default {"section":"SectionIcons_section__kkrqo","container":"SectionIcons_container__W0bT6","icon":"SectionIcons_icon__GBmld","title":"SectionIcons_title__rDRnU"};